import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import 'lib-flexible/flexible'
import '@/assets/css/reset.scss'
import Vant from 'vant';
import 'vant/lib/index.css'
import { Toast } from 'vant'
import store from '@/store'
import * as filters from '@/assets/js/filters'


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)
// import VConsoles from 'vconsole'
// let vConsole = new VConsoles()
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.use(Toast);
Vue.use(Vant);

Vue.config.productionTip = false

import { common } from './mixins/index.js'
Vue.mixin(common)

Vue.prototype.$showLoading = Toast.bind(this, {
  type: 'loading',
  message: '',
  forbidClick: true,
  loadingType: 'spinner',
  duration: 0
})
Vue.prototype.$hideLoading = Toast.clear.bind(this)

router.afterEach(() => {
  document.title = '群英荟'
}
)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
